<template>
  <div class="container fw_bg">
    <div class="fw_title">
      <div class="fw_title_title">
        余额<img @click="showBalancePopup()" src="../../assets/fx/tips.png" />
      </div>
      <div class="fw_title_price">
        ¥
        <label class="fw_title_price_lg">800.88</label>
        <div class="fw_title_price_btn">
          去赚钱
          <img src="../../assets/fx/orderArrow_white.png" />
        </div>
      </div>
    </div>
    <div class="fw_conte">
      <van-sticky>
      <div class="fw_conte_title">
        <van-row>
          <van-col span="12">
            <div @click="switchTabbar(1)" :class="[{'fw_conte_title_blockS':tabbar_index==1},'fw_conte_title_block']">
              <!--  :class="[{'indicators_block_current':key==keyVlaue},'indicators_block']" -->
              收入
              <label v-show="tabbar_index==1"></label>
            </div>
          </van-col>
          <van-col span="12">
            <div @click="switchTabbar(2)" :class="[{'fw_conte_title_blockS':tabbar_index==2},'fw_conte_title_block']">
              支出
              <label v-show="tabbar_index==2"></label>
            </div>
          </van-col>
        </van-row>
      </div>
      </van-sticky>
      <div class="fw_list">
        <div v-for="(wallet_item,wallet_index) in list" class="fw_list_block">
          <van-row>
            <van-col span="18">
              <div class="fw_list_block_left">
                <div class="fw_list_block_left_title">游泳健身服务预约</div>
                <div class="fw_list_block_left_date">2021-09-21 20:00</div>
              </div>
            </van-col>
            <van-col span="6">
              <div class="fw_list_block_right">
                -188.00
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>

    <!-- balance popup -->
    <van-popup v-model="balancePopup">
      <div></div>
    </van-popup>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        tabbar_index:1,
        balancePopup:true,



        list:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,]
      }
    },
    created() {
      // document.title='我的钱包'
    },
    watch: { },

    mounted() { },
    methods: {
      // 展示余额 popup
      showBalancePopup(){

      },
      // 切换收入 / 支出 tabbar
      switchTabbar(e){
        this.tabbar_index=e
      },

    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .fw_bg{
    background-image: url('../../assets/fx/my_wallet_bg.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% auto;
  }
  .fw_title{
    width: 100%;
    padding: 68*@vm_base 40*@vm_base 0 60*@vm_base;
    .fw_title_title{
      width: 100%;
      font-size: 32*@vm_base;
      font-weight: 400;
      color: #FBF7F1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img{
        width: 28*@vm_base;
        height: 28*@vm_base;
        margin-left: 12*@vm_base;
      }
    }
    .fw_title_price{
      width: 100%;
      font-size: 40*@vm_base;
      font-weight: 400;
      color: #FFFFFF;
      padding: 35*@vm_base 0 82*@vm_base 0;
      .fw_title_price_lg{
        font-size: 72*@vm_base;
      }
      .fw_title_price_btn{
        width: 150*@vm_base;
        height: 60*@vm_base;
        float: right;
        margin-top: 20*@vm_base;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(153deg, #4B3D31 0%, #A5865F 100%);
        border-radius: 6*@vm_base;
        font-size: 28*@vm_base;
        font-weight: 400;
        color: #FFFFFF;
        img{
          height: 24*@vm_base;
          margin-left: 12*@vm_base;
        }
      }
    }
  }
  .fw_conte{
    width: 100%;
    background: #FFFFFF;
    border-radius: 30*@vm_base 30*@vm_base 0*@vm_base 0*@vm_base;
    padding: 40*@vm_base 0*@vm_base 11*@vm_base 0*@vm_base;
    .fw_conte_title{
      width: 100%;
      padding:40*@vm_base 177*@vm_base;
      background: #FFFFFF;
      .fw_conte_title_block{
        width: 100%;
        text-align: center;
        position: relative;
        font-size: 32*@vm_base;
        font-weight: 400;
        color: #999999;
        label{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 64*@vm_base;
          height: 10*@vm_base;
          background: #F2CE88;
          margin-left: calc(50% - 32*@vm_base);
        }
      }
      .fw_conte_title_blockS{
        color: #333333;
      }
    }
    .fw_list{
      width: 100%;
      padding: 0 40*@vm_base;
      .fw_list_block{
        border-bottom: 1*@vm_base solid #E7E7E7;
        width: 100%;
        .fw_list_block_left{
          width: 100%;
          height: 174*@vm_base;
          padding: 40*@vm_base 0;
          .fw_list_block_left_title{
            width: 100%;
            font-size: 32*@vm_base;
            font-weight: 400;
            color: #333333;
            padding-bottom: 16*@vm_base;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .fw_list_block_left_date{
            width: 100%;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #999999;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .fw_list_block_right{
          width: 100%;
          height: 174*@vm_base;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          font-size: 36*@vm_base;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/fxviews/fxwallet/fxwallet.vue